import { render, staticRenderFns } from "./mainLogo.vue?vue&type=template&id=1eb7c3f4&scoped=true&"
import script from "./mainLogo.vue?vue&type=script&lang=js&"
export * from "./mainLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb7c3f4",
  null
  
)

export default component.exports